import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useTransportationModes } from '../../hooks';
import type { TransportationMode, TransportationModeFilters } from '../../models';

export interface TransportationModeFieldProps extends Omit<SelectProps<TransportationMode>, 'options'> {
  defaultFilters?: Partial<TransportationModeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<TransportationMode>['errorMessage'];
  isInvalid?: boolean;
}

export const TransportationModeField: React.FC<TransportationModeFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = useTransportationModes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
